module.exports = __webpack_public_path__ + "img/poster_icon_sxdsb.dc72a15b.png";